import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { FaMobile, FaWhatsapp } from 'react-icons/fa'
import { MdCall, MdEmail } from 'react-icons/md'
import { Link } from 'react-router-dom'

export default function Footer() {
    return (
        <div className='mt-5 p-2 p-md-5 primary-bg'>
            <Container>
                <Row>
                    <Col md={4} className='py-2 py-md-5'>
                        <div>
                            <h3>Contact Details</h3>
                            <address className='mt-4'>
                                Shop-2, 346, Gayatri Society, L.H. Road, Kapodra , Surat - 395006 <br />
                                <MdCall /> 98252 55373 | <FaWhatsapp /> 83477 63858 <br />

                                <MdEmail /> vandankapopara2111@gmail.com

                            </address>
                        </div>
                    </Col>
                    <Col md={4} className='py-2 py-md-5'>
                        <div>
                            <h3>Quick Links</h3>
                            <ul className='mt-4 list-style-none'>
                                <li><Link className='text-decoration-none text-light' to='/'> <p className=''>Home</p></Link></li>
                                <li><Link className='text-decoration-none text-light' to='/about'> <p className=''>About us</p></Link></li>
                                <li><Link className='text-decoration-none text-light' to='/products'> <p className=''>Our Products</p></Link></li>
                                <li><Link className='text-decoration-none text-light' to='/contact'> <p className=''>Contact us</p></Link></li>
                            </ul>
                        </div>
                    </Col>
                    <Col md={4} className='py-2 py-md-5'>
                        <div>
                            <h3>Our Products</h3>
                            <ul className='mt-4 list-style-none'>
                                <li><Link className='text-decoration-none text-light' to='/'> <p className=''>Velvet Fabric</p></Link></li>
                                <li><Link className='text-decoration-none text-light' to='/about'> <p className=''>Blackout Fabric</p></Link></li>
                                <li><Link className='text-decoration-none text-light' to='/products'> <p className=''>Knitting Fabric</p></Link></li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
